import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { map } from 'rxjs';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { environment } from 'src/environments/environment';
import { ICompany } from '../models/company';
import { IEmployee, IUserRole } from '../models/employee';
import { UserService } from '../services/user.service';

@Component({
    selector: 'app-company-employee-roles',
    templateUrl: './company-employee-roles.component.html',
    styleUrls: ['./company-employee-roles.component.scss'],
    standalone: false
})
export class CompanyEmployeeRolesComponent implements OnInit {

  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private appnotificationService: AppNotificationService
    ) { }

  form:  UntypedFormGroup;

  @Input() employee: IEmployee;
  @Input() company: ICompany;

  userRoles : IUserRole[];

  get userRolesArray() : UntypedFormArray {
    return this.form.get("userRoles") as UntypedFormArray
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      userRoles: this.fb.array([])
    })
    this.initData();
  }

  initData(){
    this.userService.getPermissionRoleDetails(this.employee.userId, this.company.tenantId == 'htec')
    // .pipe(
    //   map(roles => {


    //    var filteredRoles = [];

    //     if(this.company.tenantId == environment.rootTenant){
    //       filteredRoles = roles.filter(role => role.roleName.includes('Htec') || role.roleName == 'Basic');
    //     } else {
    //       filteredRoles = roles.filter(role => !role.roleName.includes('Htec')|| role.roleName == 'Basic');
    //     }

    //     const tranlsatedRoles = [];

    //     filteredRoles.map(role =>{

    //       const result = {
    //         roleId: role.roleId,
    //         enabled: role.enabled,
    //         roleName: translate(`companies.roles.${role.roleName}.name`),
    //         description: translate(`companies.roles.${role.roleName}.description`),
    //       };

    //       tranlsatedRoles.push(result);
    //     })
    //     return tranlsatedRoles;
    //   }
    //   )
    // )
    .subscribe(userRoles => {
      this.userRoles = userRoles;
      this.initForm()
    })
  }

  initForm(){
    this.userRoles.forEach(userRole => {
      this.userRolesArray.push(this.fb.group({
        roleId: userRole.roleId,
        roleName: userRole.roleName,
        description: userRole.description,
        enabled: userRole.enabled,
      }))
    })
  }

  onSubmit(){
    this.userService.updateUsersPermissionRole(this.employee.userId, this.form.value)
    .subscribe(response => {
      this.form.markAsPristine();
      this.appnotificationService.notification$.next({message: translate('companies.roles.updateSuccessful'),style:'success'})
    })
  }

}
